const imageUrl = `/images`;

export const AssetManager = {
  Logo: {
    LargeWhite: `${imageUrl}/logo/logo_large_white.png`,
    LargePrimary: `${imageUrl}/logo/logo_large_primary.png`,
    DigitalTwin: `${imageUrl}/logo/digital_twin.png`,
  },
};
